import { render, staticRenderFns } from "./MultiRegistration.vue?vue&type=template&id=2000d004&"
import script from "./MultiRegistration.vue?vue&type=script&lang=js&"
export * from "./MultiRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports